module.exports = require("@aofl/component-utils");